// Константы API
export const DEFAULT_API_BASE_URL = 'https://beta.myiti.pro100byte.ru/api';
export const API_BASE_URL = DEFAULT_API_BASE_URL;
export const CORS_PROXY = 'https://api.allorigins.win/raw?url=';
export const CACHE_TTL = 7 * 24 * 60 * 60 * 1000; // 7 дней

export const getApiBaseUrl = () => {
  try {
    if (typeof window !== 'undefined') {
      const useCustomApi = localStorage.getItem('use_custom_api') === 'true';
      const customApiUrl = localStorage.getItem('custom_api_url')?.trim();

      if (useCustomApi && customApiUrl) {
        const normalized = new URL(customApiUrl).toString().replace(/\/+$/, '');
        return normalized;
      }
    }
  } catch {
    // Fallback на дефолтный API
  }

  return DEFAULT_API_BASE_URL;
};

// Цветовые схемы
export const ACCENT_COLORS = {
  green: {
    primary: '#10B981',
    light: '#ECFDF5',
    dark: '#047857',
    glass: 'rgba(16, 185, 129, 0.12)',
    glassBorder: 'rgba(16, 185, 129, 0.25)',
  },
  blue: {
    primary: '#3B82F6',
    light: '#DBEAFE',
    dark: '#1D4ED8',
    glass: 'rgba(59, 130, 246, 0.12)',
    glassBorder: 'rgba(59, 130, 246, 0.25)',
  },
  purple: {
    primary: '#8B5CF6',
    light: '#EDE9FE',
    dark: '#5B21B6',
    glass: 'rgba(139, 92, 246, 0.12)',
    glassBorder: 'rgba(139, 92, 246, 0.25)',
  },
  orange: {
    primary: '#F97316',
    light: '#FFF7ED',
    dark: '#C2410C',
    glass: 'rgba(249, 115, 22, 0.12)',
    glassBorder: 'rgba(249, 115, 22, 0.25)',
  },
  matrix: {
    primary: '#00FF41',
    light: '#0D1A0F',
    dark: '#00CC33',
    glass: 'rgba(0, 255, 65, 0.12)',
    glassBorder: 'rgba(0, 255, 65, 0.25)',
  },
  legend: {
    primary: '#FFD666',
    light: '#FFF7E0',
    dark: '#8A6A1F',
    glass: 'rgba(255, 214, 102, 0.14)',
    glassBorder: 'rgba(255, 214, 102, 0.28)',
  }
};

// Liquid Glass тема (iOS 26)
export const LIQUID_GLASS = {
  light: {
    surfacePrimary: 'rgba(255, 255, 255, 0.72)',
    surfaceSecondary: 'rgba(255, 255, 255, 0.56)',
    surfaceTertiary: 'rgba(255, 255, 255, 0.40)',
    surfaceCard: 'rgba(255, 255, 255, 0.65)',
    background: '#f2f2f7',
    backgroundElevated: '#ffffff',
    border: 'rgba(0, 0, 0, 0.06)',
    borderStrong: 'rgba(0, 0, 0, 0.12)',
    text: '#1c1c1e',
    textSecondary: '#8e8e93',
    textTertiary: '#aeaeb2',
    headerGlass: 'rgba(255, 255, 255, 0.78)',
    tabBarGlass: 'rgba(255, 255, 255, 0.45)',
    shadowColor: 'rgba(0, 0, 0, 0.08)',
    shadowStrong: 'rgba(0, 0, 0, 0.15)',
  },
  dark: {
    surfacePrimary: 'rgba(44, 44, 46, 0.72)',
    surfaceSecondary: 'rgba(44, 44, 46, 0.56)',
    surfaceTertiary: 'rgba(44, 44, 46, 0.40)',
    surfaceCard: 'rgba(44, 44, 46, 0.65)',
    background: '#000000',
    backgroundElevated: '#1c1c1e',
    border: 'rgba(255, 255, 255, 0.08)',
    borderStrong: 'rgba(255, 255, 255, 0.16)',
    text: '#ffffff',
    textSecondary: '#8e8e93',
    textTertiary: '#636366',
    headerGlass: 'rgba(30, 30, 30, 0.72)',
    tabBarGlass: 'rgba(30, 30, 30, 0.40)',
    shadowColor: 'rgba(0, 0, 0, 0.3)',
    shadowStrong: 'rgba(0, 0, 0, 0.5)',
  },
  matrix: {
    surfacePrimary: 'rgba(13, 2, 8, 0.85)',
    surfaceSecondary: 'rgba(13, 2, 8, 0.70)',
    surfaceTertiary: 'rgba(0, 255, 65, 0.06)',
    surfaceCard: 'rgba(13, 2, 8, 0.80)',
    background: 'transparent',
    backgroundSolid: '#0D0208',
    backgroundElevated: '#0A0A0A',
    border: 'rgba(0, 255, 65, 0.12)',
    borderStrong: 'rgba(0, 255, 65, 0.25)',
    text: '#00FF41',
    textSecondary: '#00AA2A',
    textTertiary: '#006618',
    headerGlass: 'rgba(13, 2, 8, 0.88)',
    tabBarGlass: 'rgba(13, 2, 8, 0.75)',
    shadowColor: 'rgba(0, 255, 65, 0.15)',
    shadowStrong: 'rgba(0, 255, 65, 0.3)',
  }
};

// Версия приложения
export const APP_VERSION = process.env.REACT_APP_APP_VERSION || '2.3.3-web-beta';
export const APP_DEVELOPERS = 'студентами группы 125-1 в составе команды PRO100BYTE Team';
export const APP_SUPPORTERS = 'ХГУ им. Н.Ф. Катанова и ООО "Скалк Софт"';
export const BUILD_VER = process.env.REACT_APP_BUILD_VER || 'git-web-9e2798a';
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || '22.04.2026';

// Дни недели
export const WEEKDAYS = [
  "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"
];

// Названия экранов (без карты)
export const SCREENS = {
  SCHEDULE: 'Расписание',
  UNIFIED_WINDOW: 'Единое окно',
  FRESHMAN: 'Первокурснику',
  NEWS: 'Новости',
  SETTINGS: 'Настройки'
};

// Коды курсов
export const COURSES = [
  { id: -1, label: 'Магистратура' },
  { id: 1, label: '1 курс' },
  { id: 2, label: '2 курс' },
  { id: 3, label: '3 курс' },
  { id: 4, label: '4 курс' },
  { id: 5, label: '5 курс' }
];

// Режимы отображения расписания
export const SCHEDULE_VIEW_MODES = {
  DAY: 'day',
  WEEK: 'week'
};

// GitHub репозиторий
export const GITHUB_REPO_URL = 'https://github.com/PRO100BYTE/MyKHSU';

// Ключи для хранения настроек
export const STORAGE_KEYS = {
  THEME: 'theme',
  ACCENT_COLOR: 'accentColor'
};

// Функция для получения новогоднего текста
export const getNewYearText = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  if (month === 1 && day >= 1 && day <= 31) return `С новым ${year} годом!`;
  if (month === 12 && day >= 1 && day <= 31) return `С наступающим ${year + 1} годом!`;
  return '';
};

export const isNewYearPeriod = () => {
  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  return (month === 12 && day >= 1) || (month === 1 && day <= 31);
};

export const getHolidayInfo = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  if (month === 1 && day === 25) return { text: 'С Днём студента!', icon: 'school', type: 'student-day' };
  if (month === 1 && day >= 1 && day <= 14) return { text: `С новым ${year} годом!`, icon: 'sparkles', type: 'new-year' };
  if (month === 2 && day === 14) return { text: 'С Днём святого Валентина!', icon: 'heart', type: 'valentines-day' };
  if (month === 2 && day === 23) return { text: 'С Днём защитника Отечества!', icon: 'shield', type: 'defender-day' };
  if (month === 3 && day === 8) return { text: 'С 8 Марта!', icon: 'flower', type: 'womens-day' };
  if (month === 4 && day === 12) return { text: 'С Днём космонавтики!', icon: 'rocket', type: 'cosmonautics-day' };
  if (month === 5 && day === 1) return { text: 'С Праздником Весны и Труда!', icon: 'sunny', type: 'may-day' };
  if (month === 5 && day === 9) return { text: 'С Днём Победы!', icon: 'star', type: 'victory-day' };
  if (month === 9 && day === 1) return { text: 'С Днём знаний!', icon: 'book', type: 'knowledge-day' };
  if (month === 9 && day === 3) return { text: 'Я календарь переверну...', icon: 'calendar', type: 'september-3' };
  if (month === 10 && day === 5) return { text: 'С Днём преподавателя!', icon: 'easel', type: 'teacher-day' };

  const startOfYear = new Date(year, 0, 0);
  const diff = today - startOfYear;
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (dayOfYear === 256) return { text: 'С Днём программиста!', icon: 'code-slash', type: 'programmer-day' };

  if (month === 12 && day >= 20) return { text: `С наступающим ${year + 1} годом!`, icon: 'sparkles', type: 'new-year' };
  return null;
};
